<template>
  <div class="of-h" v-loading="loading">
    <div class="flex-box al-c card-title">
      <img class="ml10 mr5" :src="`${baseUrl}images/icon-home-serve.png`" />
      <span class="font-20">个人应用</span>
    </div>

    <el-row class="w100" v-loading="loading">
      <el-col :span="col" v-for="(item, index) in list" :key="index">
        <a class="block w100 pt20 cu-p tx-c app-item" target="_blank" @click="jumpTo(item)">
          <img
            class="app-img"
            :src="item.appIcon ? item.appIcon : `${baseUrl}images/icon-app.png`"
            style="width: 60px; height: 60px; border-radius: 50%;"
          />
          <!-- <el-image class="app-img" :src="item.appIcon" lazy style="width: 60px; height: 60px; border-radius: 50%;">
            <img :src="`${baseUrl}images/icon-app.png`" width="60" height="60" slot="error">
          </el-image>-->
          <p class="mt10 pl20 pr20 font-14 ellipsis">{{ item.appName }}</p>
        </a>
      </el-col>
      <el-col class="pt20 pb20 tx-c grey font-14" :span="24" v-if="list.length == 0">暂无可用应用</el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CardApp",
  components: {},
  props: ["w", "h"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      list: [],

      col: 8
    };
  },
  computed: {
    pageSize() {
      return this.w * 3 * (this.h * 2);
    },
    ...mapGetters(["userToken"])
  },
  created() {
    this.fetchList();
  },
  mounted() {},
  destroyed() {},
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          "/app/appPermitList",
          this.$qs.stringify({
            pageNum: 1,
            pageSize: this.pageSize
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.list = data.resData.list;
            this.$nextTick(() => {
              this.computeCol();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //  aws=aws应用，tokenUrl=单点a标签带token跳转，resultUrl = 返回url再进行跳转
    jumpTo(item) {
      let url = item.appUrl;
      if (item.appType === "aws") {
        // aws应用
        url = url + "?sid=" + this.userToken;
        window.open(url);
      } else if (item.appType === "tokenUrl") {
        // 外部应用
        let authorize = window.sessionStorage.getItem("authorization");
        url = url + `?${item.appTokenName}=` + authorize.split(" ")[1];
        window.open(url);
      } else if (item.appType === "resultUrl") {
        // 返回url跳转
        this.getResulUrl(url);
      } else {
        // 自己的应用
        window.open(url);
      }
      this.serverInsert(item);
    },
    getResulUrl(url) {
      let token = window.sessionStorage.getItem("authorization");
      this.$http
        .get(url, {
          headers: {
            Authorization: "Basic bmVpemhlbjpuZWl6aGVu",
            token: token
          }
        })
        .then(({ data }) => {
          if (data.resCode === 0) {
            let url = data.resData;
            window.open(url);
          }
        })
        .catch();
    },
    //访问统计计数器
    serverInsert(item) {
      this.$http
        .post(
          "/statistical/serverInsert",
          this.$qs.stringify({
            serviceId: item.id,
            appType: 9
          })
        )
        .then(() => {})
        .catch(() => {});
    },
    // 每次获取计算列个数
    computeCol() {
      switch (this.w) {
        case 1:
          this.col = 8;
          break;
        case 2:
          this.col = 4;
          break;
        case 3:
          this.col = 3;
          break;
        default:
          break;
      }
    },
    resizedEvent() {
      this.fetchList();
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
.card-title {
  height: 40px;
}

.app-item {
  height: 140px;
}

.app-item:hover {
  background: #edf5fe;
}
.app-img {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>
